import { InterfaceString } from "@interface/ICommon";

export const MasterMedia: InterfaceString = {
  xs: "480px",
  sm: "576px",
  md: "768px",
  lg: "1024px",
  xl: "1440px",
  xxl: "1600px",
};
